import React from "react";

const WorkForceCaseComponent = ({
                                    text,
                                    imgPath,
                                    imgAltText = "some picture",
                                    workforceValue,
                                    workforceType,
                                    setWorkforceType,
                                }) => {

    // imgAltText should always be provided for better accessibility for all users
    return (
        <button onClick={() => {
            if (workforceType === workforceValue) {
                setWorkforceType(0);
            } else {
                setWorkforceType(workforceValue);
            }
        }} type="button" className="">
            <div
                className={`border-2 border-light-grey-200 border-solid rounded-xl grid grid-cols-4 justify-items-center py-2 hover:ring-2 hover:ring-dark-blue-100
                    ${workforceType === workforceValue ? "ring-2 ring-dark-blue-100" : " "}
                `}>
                <div className="w-1/2 h-5/6 flex justify-center">
                    <img className="h-[30px]" src={imgPath} alt={imgAltText ?? ""}/>
                </div>
                <div className="col-span-2 justify-self-center self-center">
                    <p className="text-xs font-bold text-dark-blue-200">{text}</p>
                </div>
            </div>
        </button>
    );
};

export default WorkForceCaseComponent;
